export enum ColumnasMostrar { CASOS = 0, PORCENTAJE = 1, TODAS = 2 }
